import InputNumber from 'rc-input-number'
import styled from 'styled-components'

/**
 * Historically, we used '<input type="number" value={ num ?? '' } onChange={ evt => evt.target.valueAsNumber } />'.
 * But there are issues with the way the browser handles type=number.
 * 
 * For example, if the user provides ',' instead of '.' (or the opposite), the field is cleared depending on the locale
 * (without a way to correct the value, because event.target.value = '').
 * 
 * Instead, we should now use the popular InputNumber component with a few presets for decimals.
 * Note that we still rely on <input type="number" /> for integers (we add step=1 to makes it clear).
 */
export const StyledInputDecimal = styled(InputNumber)``

export const NoRightBorderStyledInputDecimal = styled(InputNumber)<{ $marginBottom?: number | string }>`
  input {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    ${ props => typeof props.$marginBottom === 'undefined' ? '' : `margin-bottom: ${props.$marginBottom} !important;`}
  }
`

for (const klass of [NoRightBorderStyledInputDecimal, StyledInputDecimal]) {
  klass.defaultProps = {
    parser: value => value.replace(',', '.'),
    type: 'text',
    inputMode: 'decimal'
  }
}
